import { signerIdentity, signerPayer } from '@metaplex-foundation/umi';
import { createSignerFromWalletAdapter } from './createSignerFromWalletAdapter.mjs';

const walletAdapterIdentity = (walletAdapter, setPayer = true) => ({
  install(umi) {
    const signer = createSignerFromWalletAdapter(walletAdapter);
    umi.use(signerIdentity(signer, setPayer));
  }
});
const walletAdapterPayer = walletAdapter => ({
  install(umi) {
    const signer = createSignerFromWalletAdapter(walletAdapter);
    umi.use(signerPayer(signer));
  }
});

export { walletAdapterIdentity, walletAdapterPayer };
//# sourceMappingURL=plugins.mjs.map
